import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GroupI } from '../../../interfaces/groups/group.interface';
import { GroupsService } from '../../../services/groups.service';
import { MessageService } from '../../../services/message.service';

@Component({
  selector: 'app-group-form',
  templateUrl: './group-form.component.html',
  styleUrls: ['./group-form.component.scss']
})
export class GroupFormComponent implements OnInit {

  @Input() group: GroupI;
  @Output() groupSubmit = new EventEmitter();
  @Output() closeModal = new EventEmitter();

  public groupForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private groupServ: GroupsService,
  ) {
    this.groupForm = this.formBuilder.group({
      id: [''],
      name: [''],
      initial_date: ['']
    });
  }

  ngOnInit(): void {
    this.fillUserForm(this.group);
  }

  fillUserForm(data) {
    this.groupForm.setValue({
      id: (data && data.id) ? data.id : '',
      name: (data && data.name) ? data.name : '',
      initial_date: (data && data.initial_date) ? data.initial_date : '',
    });
    if (data && data.id > 0) {
      this.groupForm.controls.initial_date.disable();
    }
  }

  save() {
    if (this.groupForm.invalid) {
      return false;
    }

    this.messageService.confirmRequest('¿Estás seguro de querer proceder ?').then((data) => {
      if (data.value) {
        if (this.groupForm.controls.id.value || this.groupForm.controls.id.value > 0) {
          this.groupServ.update(this.group.id, this.groupForm.value).subscribe(res => {
            if (res.ok === true) {
              this.groupSubmit.emit(true);
              this.onClose();
              this.messageService.printStatus(res.message, 'success');
            }
          }, error =>  {
            this.messageService.printStatus(error.error.errors, 'error');
            console.log(error);
          });
        } else {
          this.groupServ.add(this.groupForm.value).subscribe(res => {
            if (res.ok === true) {
              this.groupSubmit.emit(true);
              this.onClose();
              this.messageService.printStatus(res.message, 'success');
            }
          }, error =>  {
            this.messageService.printStatus(error.error.errors, 'error');
            console.log(error);
          });
        }
      } else {
        this.messageService.dismissDelete();
      }
    });
  }

  onClose() {
    this.groupForm.reset();
    this.closeModal.emit();
  }



}
